

































































import { Component, Vue } from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';
import { ActionNames } from '@/constants/ActionNames';
import validateEmail from '@/utils/validateEmail';
import { validateInputs } from '@/utils/validateInputs';

interface RegisterData {
  firstName: string;
  middleName?: string;
  surName: string;
  email: string;
  cardNumber: string | number;
}

@Component({
  components: {
    Loading,
  },
})
export default class Register extends Vue {
  public loading: boolean = false;

  public error: {
    type: string,
    message: string,
    show: boolean,
  } = {
    show: false,
    type: '',
    message: '',
  };

  public middleName: string = '';

  public registerData: RegisterData = {
    firstName: '',
    surName: '',
    email: '',
    cardNumber: '',
  };

  public async doRegister() {
    this.loading = true;

    if (validateEmail(this.registerData.email) && validateInputs(this.registerData)) {
      this.registerData = {
        ...this.registerData,
        middleName: this.middleName,
      };

      const success = await this.$store.dispatch(ActionNames.REGISTER, this.registerData);

      if (success) {
        this.error = {
          type: 'success',
          message: 'Er is een account aangemaakt voor deze gebruiker. Hij/zij krijgt hierover een e-mail.',
          show: true,
        };
      } else {
        this.error = {
          type: 'warning',
          message: 'Er ging iets fout tijdens het aanmaken van een account voor deze gebruiker',
          show: true,
        };
      }
    } else {
      this.error = {
        type: 'warning',
        message: 'Vul alle gegevens in',
        show: true,
      };
    }

    this.loading = false;
  }
}
